/**
 *
 * FBAdminAnswerCard
 *
 */

import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { Button } from 'antd';

import { AddToCalendarButton } from 'add-to-calendar-button-react';

// icons
import CustomIcons from 'components/CustomIcons';

// global user
import { useGetLocalUser } from 'engine/Contexts/User.context';

// custom react-multi-date-picker
import { DateObject } from 'react-multi-date-picker';
import { timeFormat, dateFormat } from 'utils/moment/moment.constant';

function FBAdminAnswerCard({
  currentElement,
  adminAnswer,
  answeredRecipient,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-admin-answer', className);

  const localUser = useGetLocalUser()();

  const formatDateTimeValue = useCallback((value, format) => {
    if (!!!value) {
      return '';
    }

    if (typeof value == 'object') {
      return !!value && value.format(format);
    } else {
      return !!value && new DateObject(value).format(format);
    }

  }, [])

  const calendarData = {
    name: currentElement?.title,
    description: `Votre rendez-vous a été agencé au ${adminAnswer?.slot?.dateFormat}, ${formatDateTimeValue(adminAnswer?.slot?.timeFrom, timeFormat)} - ${formatDateTimeValue(adminAnswer?.slot?.timeTo, timeFormat)}`,
    startDate: new Date(adminAnswer?.slot?.date).toISOString(),
    endDate: new Date(adminAnswer?.slot?.date).toISOString(),
    startTime: formatDateTimeValue(adminAnswer?.slot?.timeFrom, timeFormat),
    endTime: formatDateTimeValue(adminAnswer?.slot?.timeTo, timeFormat),
    options: ['Apple', 'Google', 'iCal', 'Microsoft365', 'Outlook.com', 'Yahoo'],
  //  timeZone: "Europe/Berlin",
    location: "",
    iCalFileName: "Reminder-Event",
    label: 'Ajouter à votre calendrier',
    language: 'fr',
    checkmark: false,
    icons: false
  };

  return !!adminAnswer && (
    <div {...rest} className={childClassNames}>

      <div className="slot-wrapper">
        <div className="slot slot-date">
          <CustomIcons className="slot-icon" type="calendar" />
          {adminAnswer?.slot?.dateFormat}
        </div>
        <div className="slot slot-time">
          <CustomIcons className="slot-icon" type="time" />
          {`${formatDateTimeValue(adminAnswer?.slot?.timeFrom, timeFormat)} - ${formatDateTimeValue(adminAnswer?.slot?.timeTo, timeFormat)}`}
        </div>
      </div>

      <div className="slot-description">
        L’enseignant a validé cet horaire pour votre rendez-vous
      </div>

      {(!!answeredRecipient &&
        answeredRecipient?.description?.firstname && answeredRecipient?.description?.lastname &&
        localUser?._id == answeredRecipient?._id
      ) && (
          <div className="answered-parent">
            <span>A répondu : </span>
            <span className="name">{`${answeredRecipient?.description?.lastname} ${answeredRecipient?.description?.firstname}`}</span>
          </div>
        )}

      <AddToCalendarButton
        {...calendarData}
      >
        Ajouter à votre calendrier
      </AddToCalendarButton>

    </div>
  );
}

FBAdminAnswerCard.defaultProps = {
  adminAnswer: null,
  answeredRecipient: null,
};

export default memo(FBAdminAnswerCard);
